<swiper-container class="product-item-2 swiper-container" [appSwiper]="config" init="false" >
  @for (product of product; track product) {
    <swiper-slide class="swiper-slide">
      <mat-card appearance="outlined" class="fx-col">
        @if (!contentLoaded) {
          <ngx-skeleton-loader loadingText="Ziplingo"
            count="1"
            [theme]="{ width: '180px', 'border-radius': '0', height: '180px' }"
          ></ngx-skeleton-loader>
        }
        @if (contentLoaded) {
          <div class="product-img">
            <a class="product-link" (click)="changeProductDetail(product.ItemID)">
              <img [default]="'assets/images/product/no-img.png'" [src]="configService.localSettings.Disco.DiscoUrl+product.ImageUrl" alt="">
            </a>
          </div>
        }
        <div class="product-info-wrapper">
          @if (!contentLoaded) {
            <ngx-skeleton-loader loadingText="Ziplingo"
              count="2"
              [theme]="{ 'border-radius': '0', height: '20px' }"
            ></ngx-skeleton-loader>
          }
          @if (contentLoaded) {
            <div class="title-wrap">
              <h4 class="color1-f-s-10">{{product?.ProductName}}</h4>
            </div>
          }
          @if (contentLoaded) {
            <div class="fx-row fx-main-between fx-cross-center">
              @if (product && product.Prices && product.Prices.length>0) {
                <p class="color-f-s-10">{{product?.Prices[0].Price | currency : companyService.selectedCurrency.CurrencyCode}}</p>
              }
            </div>
          }
        </div>
      </mat-card>
    </swiper-slide>
  }
  <button slot="container-end" mat-mini-fab class="swiper-button-prev swipe-arrow l-20"><mat-icon>keyboard_arrow_left</mat-icon></button>
  <button slot="container-end" mat-mini-fab class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
</swiper-container>
